import { render, staticRenderFns } from "./DeleteSubmission.vue?vue&type=template&id=50c48b19"
import script from "./DeleteSubmission.vue?vue&type=script&lang=js"
export * from "./DeleteSubmission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports